module.exports = __webpack_public_path__ + "img/example.faa2cf59.png";